import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AllTestTableComp from "./Component/AllTestTableComp"

const AllTestTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <AllTestTableComp/>
        </div>
        <Footer />
        </>
    )
}

export default AllTestTable